export const SETTING_DEACTIVATE_REQUEST = 'SETTING_DEACTIVATE_REQUEST';
export const SETTING_DEACTIVATE_SUCCESS = 'SETTING_DEACTIVATE_SUCCESS';
export const SETTING_DEACTIVATE_FAIL = 'SETTING_DEACTIVATE_FAIL';

export const settingDeactivateActions = {
  SETTING_DEACTIVATE_SUCCESS,
  SETTING_DEACTIVATE_REQUEST,
  SETTING_DEACTIVATE_FAIL
};
